<svelte:options runes={false} />

<script>
  import CurrencySelect from '../components/CurrencySelect.svelte';
  import SectionHeading from '../components/SectionHeading.svelte';

  export let newProjectName;
  export let newProjectCurrency;
  export let newProjectShowPaymentProgressPercent;
  export let creatingProject;
  export let onCreateProject;
  export let onBack;
</script>

<section class="panel operator-settings-panel">
  <SectionHeading eyebrow="Operator" title="New project">
    <svelte:fragment slot="trailing">
      <button type="button" on:click={onBack}>‹ Back to desk</button>
    </svelte:fragment>
  </SectionHeading>

  <form class="project-create" on:submit|preventDefault={onCreateProject}>
    <label>
      Project name
      <input bind:value={newProjectName} maxlength="120" />
    </label>
    <CurrencySelect
      label="Project currency"
      bind:value={newProjectCurrency}
      disabled={creatingProject}
    />
    <label class="inline-check">
      <input bind:checked={newProjectShowPaymentProgressPercent} type="checkbox" />
      Show payment progress percentages on public invoices
    </label>
    <button type="submit" disabled={creatingProject}>
      {creatingProject ? 'Creating project…' : 'Create project'}
    </button>
    <p class="quiet">
      A new project starts empty, with the standard payment policy. You can review that
      policy after creating it.
    </p>
  </form>
</section>
